export default [
	{
		path: "/pros/bookings",
		exact: true,
		component: "Bookings",
		load: true,
	},
];
